import React, { useState, useEffect } from "react";
import Modal from "@ui-components/Modal";
import RadioGroup from "@ui-components/RadioGroup";
import { useIntl } from "react-intl";

export const SelectKcolorPriceModal = ({onConfirm, onExit}) => {
    const intl = useIntl();
    const [ kcolorPriceDirection, setKcolorPriceDirection ] = useState<null | "kerakoll" | "tintometer">(null);

    return (
      <Modal
        fixed
        closeClickOutside={false}
        confirmText={intl.formatMessage({
          id: "confirm",
          defaultMessage: "Conferma",
        })}
        onConfirm={() => {
          onConfirm(kcolorPriceDirection);
        }}
        onExit={onExit}
      >
        <p>
          {intl.formatMessage({
            id: "kcolor_price_choose_text",
            defaultMessage:
              "Nel preventivo sono presenti alcuni prodotti della collezione K-color. Per questi è necessario indicare chi sarà a produrre le tinte.",
          })}
        </p>
        <div className="flex justify-center gap-4 mt-4">
          <RadioGroup
            options={[
              {
                name: intl.formatMessage({
                  id: "product_by_resale",
                  defaultMessage: "Miscelato e prodotto in rivendita",
                }),
                value: "tintometer",
              },
              {
                name: intl.formatMessage({
                  id: "product_by_kerakoll",
                  defaultMessage: "Miscelato e prodotto da kerakoll",
                }),
                value: "kerakoll",
              },
            ]}
            currentValue={kcolorPriceDirection}
            onChange={(v: "kerakoll" | "tintometer") => {
              setKcolorPriceDirection(v);
            }}
          />
        </div>
      </Modal>
    );
}